import { RangePicker } from '@/pages/home/components/RangePicker/RangePicker';

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Select, ConfigProvider, DatePicker, Bubble } from 'tea-component'
import '@/pages/home/components/RangePicker/index.scss'
import './index.scss'
// import 方式
import moment, { Moment } from "moment";
import { shortcutOption, DateShortcutType, ShortcutOptionType } from '@/pages/home/components/RangePicker/_config';
import { IAutoRange } from '@/pages/home/components/RangePicker/CalendarTable';
// moment.locale('en');

// const RangePicker = DatePicker.RangePicker;

interface OptionsMapType {
  [type: string]: {
    value: string,
    text: string,
    text_cn?: string
  }
}

interface IShotcutItemProps {
  item: DateShortcutType;
  selectedLeftType: string;
}

export interface IAutoRangeMap {
  [type: string]: IAutoRange
}

const typeDateList = ['1day', '3days', '7days', '30days', 'date', 'hour'];

const autoRangeMap: IAutoRangeMap = {
  '1day': {
    length: 0,
    autoPosition: 'head'
  },
  '3days': {
    length: 2,
    autoPosition: 'head'
  },
  '7days': {
    length: 6,
    autoPosition: 'head'
  },
  '30days': {
    length: 29,
    autoPosition: 'head'
  }
};

const optionsMap: OptionsMapType = {
  '1day': { value: "1day", text: "1 Day", text_cn: '1天' },
  '3days': { value: "3days", text: "3 Days", text_cn: '3天' },
  '7days': { value: "7days", text: "7 Days", text_cn: '7天' },
  '30days': { value: "30days", text: "30 Days", text_cn: '30天' },
  hour: { value: "hour", text: "Hour", text_cn: '时' },
  date: { value: "date", text: "Day", text_cn: '日' },
  week: { value: "week", text: "Week", text_cn: '周' },
  month: { value: "month", text: "Month", text_cn: '月' },
  year: { value: "year", text: "Year", text_cn: '年' }
};

export default (props: any) => {
  const {
    value = [moment(), moment()],
    defaultValue = {},
    type: typeProps,
    typeList = ['date'],
    disabled = false,
    timeTabDisabled = false,
    showSelectType = true,
    showShortcut = true,
    setShortcutOption,
    startOfWeek = 0,
    onChange,
    customOption = {},
    language,
    startOfTime = '', // 所有时间的起始时间，startOfTime和latestDate，不是所有地方都需要，需要从外部传入参数
    latestDate = {
      // date:moment().subtract(1, 'day'),
      // week: moment().weekday(-7),
      // month: moment().subtract(1,'month').startOf('month')
    }, //最新有数据的时间
    isReseted,
    showTips = false,
    tipsInfo = null,
    onTimeChange,
    extraShortcut, // 额外的快捷选项，第二列展示
    overlayClassName = '',
    typeSelectOverlayClassName = '',
    disabledDate = null,
    setIsChangeDefaultType, //判断是否为未选择日期直接切换时间粒度类型
    setTimeShortcutType,  //返回日期组件选择的快捷键类型
    syncInput = true,
    showRangePicker = true,
    ...restProps
  } = props;

  // console.log('rangepicker', props);
  const type = typeProps || 'date';
  const isCN = ['cn', 'zh_CN'].includes(language);

  const calendarInfoRef = useRef<any>({
    [type]: value
  });

  const childRef = useRef<any>();
  // const [calendarType, setCalendarType] = useState(type);
  // 左侧快捷选择状态设置
  const [selectedLeftType, setSelectLeftType] = useState('')
  // 选择日期类型
  const handelChangeType = useCallback((type: string) => {
    // console.log('handelChangeType', type);
    // 防止单个日期时选中下拉的选项出现无效时间的问题
    if (typeList?.length <= 1) return;
    const value = calendarInfoRef.current?.[type]
    setSelectLeftType('')
    setTimeShortcutType?.('')
    if (value && !isReseted) {
      onChange(value, type);
    } else {
      onChange(defaultValue?.[type] || [null, null], type);
    }
  }, [onChange, isReseted, setTimeShortcutType]);

  // 接管rangepicker 中的onchange
  const handleChangeValue = useCallback((value: Array<Moment | '' | null>, context: any, isShortcut = false) => {
    setSelectLeftType('')
    if (!isShortcut) {
      setTimeShortcutType?.('');
    }
    if (setIsChangeDefaultType) setIsChangeDefaultType(type);
    calendarInfoRef.current[type] = value;
    onChange(value, type);
  }, [onChange, setTimeShortcutType])
  // 接管rangepicker 中的onchange
  const handleChangeSingleValue = (value: Moment | '' | null)=>{
    handleChangeValue([moment(value),moment(value)],null)
  }
  const options = typeList.map((val: string) => {
    const { value, text, text_cn } = optionsMap[val] || {};
    if (isCN) {
      return { value, text: text_cn }
    }
    return { value, text };
  });

  // const calendarType: string = type === 'hour' ? 'date' : type;
  const calendarType: string = typeDateList.includes(type) ? 'date' : type;
  const showTime: boolean = type === 'hour';
  const curDefaultValue = defaultValue[type];
  const curProps: any = customOption[type];

  const ShotcutItem = useMemo(() => {
    return (props: IShotcutItemProps) => {
      const { item, selectedLeftType } = props;
      return <p
        className={`dtb-rangepicker-shortcut ${selectedLeftType === item?.name && 'dtb-rangepicker-shortcut-hover'}`}
        onClick={() => {
          // console.log('item', item, type);
          handleChangeValue(item.onClick(), type, true);
          setSelectLeftType(item?.name);
          setTimeShortcutType && setTimeShortcutType(item?.name);
          //  关闭时间组件弹出窗
          childRef?.current?.setPopActive()
        }}>{isCN ? item.nameCN : item.name}</p>
    }
  }, [isCN, handleChangeValue, setTimeShortcutType]);

  // 额外的快捷扩展
  const extraShortcutList = useMemo(() => {
    const extraShortcutList = extraShortcut?.[type] || [];
    if (!showShortcut || extraShortcutList.length < 1) {
      return null;
    }
    return extraShortcutList;
  }, [type, extraShortcut]);

  const shortcut = useMemo(() => {
    // 配置左侧栏快捷操作
    let shortcutList: DateShortcutType[] = [];
    if (showShortcut) {
      shortcutList = shortcutOption(
        startOfTime,
        latestDate,
      )?.[type] || [];
    }
    // 是否有自定义左侧栏快捷操作
    if (showShortcut && typeof setShortcutOption === 'function') {
      // 此处是浅拷贝，注意setShortcutOption不要修改参数
      const newShortcutOption: ShortcutOptionType = setShortcutOption({ ...shortcutOption(startOfTime, latestDate) });
      if (React.isValidElement(newShortcutOption)) {
        return React.Children.map(newShortcutOption, (child: any) => {
          return React.cloneElement(
            child,
            {
              handleChangeValue,
              setSelectLeftType,
              childRef,
              type,
              selectedLeftType
            }
          );
        })
      } else {
        shortcutList = newShortcutOption?.[type] || [];
      }
    }
    if (shortcutList.length < 1) {
      return null;
    }

    if (!extraShortcutList) {
      return shortcutList.map((item: DateShortcutType) => {
        return <ShotcutItem key={item.name} item={item} selectedLeftType={selectedLeftType} />
      });
    }

    return (<div className="db-shotcut-wrap">
      <div className="db-shotcut-column">
        {
          shortcutList.map((item: DateShortcutType) => {
            return <ShotcutItem key={item.name} item={item} selectedLeftType={selectedLeftType} />
          })
        }
      </div>
      <div className="db-shotcut-column">
        {
          extraShortcutList.map((item: DateShortcutType) => {
            return <ShotcutItem key={item.name} item={item} selectedLeftType={selectedLeftType} />
          })
        }
      </div>
    </div>);
  }, [type, extraShortcutList, setShortcutOption, selectedLeftType, ShotcutItem]);

  const rangePrefix = useMemo(() => {
    if (showSelectType) {
      return null;
    }
    const { text, text_cn } = optionsMap[type] || {};
    return <div className={isCN ? 'dtb-rangepicker-label-prefix-cn' : 'dtb-rangepicker-label-prefix'}>{isCN ? text_cn : text}</div>;
  }, [showSelectType, type, language]);

  const autoRange = useMemo(() => {
    return autoRangeMap?.[type];
  }, [type]);

  // 同步外部值
  useEffect(() => {
    if (calendarInfoRef.current[type] !== value) {
      if (showShortcut) {
        setSelectLeftType('');
      }
      calendarInfoRef.current[type] = value;
    }
  }, [value, type, showShortcut]);

  return (
    <>
      {showSelectType &&
        <Bubble
          dark
          escapeWithReference
          flipped={false}
          destroyOnClose={false}
          content={showTips ? tipsInfo : null}
        >
          <Select
            appearance="button"
            options={options}
            disabled={timeTabDisabled || disabled }
            value={type}
            onChange={value => handelChangeType(value)}
            className="dtb-datepicker-prefix"
            overlayClassName={typeSelectOverlayClassName}
            matchButtonWidth={true}
          />
        </Bubble>
      }
      <ConfigProvider locale={language}>
        {
          showRangePicker ?
            <RangePicker
              rangePrefix={rangePrefix}
              key={type}
              autoRange={autoRange}
              fixDate={true}
              restoreView={true}
              syncInput={syncInput}
              {...restProps}
              {...curProps}
              ref={childRef}
              disabled={disabled}
              showSelectType={showSelectType}
              header={shortcut}
              startOfWeek={startOfWeek}
              calendarType={calendarType}
              disabledDate={disabledDate?.[type]}
              value={value}
              defaultValue={curDefaultValue}
              showTime={showTime}
              onChange={handleChangeValue}
              onTimeChange={onTimeChange}
              overlayClassName={`dtb-rangepicker-overlay${extraShortcutList ? ' dtb-rangepicker-has-extra-shotcut' : ''}${overlayClassName ? ' ' + overlayClassName : ''}`}
            />
            :
            <DatePicker
            style={{minWidth:'280px'}}
            value={value[1]}
            className={'dbi-custom-date-picker'}
            // clearable
            defaultValue={moment()}
            onChange={value => handleChangeSingleValue(value)}
          />
        }


      </ConfigProvider>
    </>
  );
};
